var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column login-container justify-center align-center"},[_c('login-view',{on:{"logged-in":_vm.onLoggedIn}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }